//!#system	

<template>
	<v-card>
		<v-card-title>
			<span class="headline">Import File</span>
		</v-card-title>
		<v-progress-linear v-if="isLoading" indeterminate color="cyan"></v-progress-linear>
		<div v-if="!fileRef">
			<v-card-text>
				<iframe 
					class="iframe-placeholder" 
					:src="iframeSrc" 
					ref="uploader" 
					width="100%"
					height="104" 
					frameBorder="0"
					style="overflow:hidden;"
					scrolling="no"
				/>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="closeDialog()">Exit</v-btn>
			</v-card-actions>
		</div>
		<div v-else-if="isDone">
			<v-card-text>
				<div class="mb-6">
					<v-icon small color="success">mdi-check</v-icon>
					Success!
				</div>
				<div class="mb-6">
					<v-btn :to="targetListScreen" small class="mt-2 mr-2">View Data</v-btn>
					<v-btn :to="linkTaskResult" small class="mt-2">View Task Result</v-btn>
				</div>

			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="closeDialog()">Exit</v-btn>
			</v-card-actions>
		</div>
		<div v-else>
			<v-card-text>
				Your file has uploaded.
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="closeDialog()">Exit</v-btn>
				<v-btn color="primary" @click="doAction()" :disable="!fileRef" :loading="isImporting">Perform Import</v-btn>
			</v-card-actions>
		</div>
	</v-card>
</template>

<script>
import tools from '@/tools';
import apiService from '@/apiService';
export default {
	props: {
		routeInfo: {
			type: Object
		},
		detail: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			isLoading: false,
			isUploading: false,
			isImporting: false,
			fileRef: '',
			isDone: false,
			importResult: {}
		}
	},
	computed: {
		submitText() {
			return 'Next';
		},
		iframeSrc() {
			return '/ui/uploader.html?tc=DataFile&pf=yes&memo=' + encodeURIComponent(this.detail.mappingCode)
		},
		targetListScreen() {
			const listRouteInfo = tools.fromBucket(this.detail.bucket);
			return tools.linkToList(listRouteInfo);
		},
		linkTaskResult() {
			return tools.linkToDetail({ namespace: 'bpa', pluralName: 'taskResults', id: this.importResult.taskResult.id });
		}
	},
	methods: {
		closeDialog() {
			this.$emit('close');
		},
		doAction() {
			this.isImporting = true;
			apiService.action({
				...this.routeInfo,
				action: 'importFile',
				method: 'post',
				payload: {
					id: this.fileRef
				}
			}, (err, response) => {
				this.isImporting = false;
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err.message
					});
				} else {
					this.isDone = true;
					this.importResult = response;
				}
			});
		}
	},
	mounted() {
		window.onmessage = (e) => {
			console.log('ApplicationFile', 'onmessage', e.data);
			if (e.data.file_ref) {
				this.fileRef = e.data.file_ref;
			}
		}
	}
}
</script>